"use strict";

exports.__esModule = true;

// Helper to call a given function, only once
exports.default = function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/utils/once.js
// module id = ./node_modules/styled-components/lib/utils/once.js
// module chunks = 5217438866945042000 7356694376651505000 9453687551911655000 13994203391546835000